module.exports = __webpack_public_path__ + "img/improve_digital_new.9104f4c.png";